/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponsePatientDto } from '../../models/response-patient-dto';

export interface PatientsControllerFindOne$Params {

/**
 * The tenant of the patient
 */
  tenant: string;

/**
 * The patient id
 */
  id: string;
}

export function patientsControllerFindOne(http: HttpClient, rootUrl: string, params: PatientsControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponsePatientDto>> {
  const rb = new RequestBuilder(rootUrl, patientsControllerFindOne.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponsePatientDto>;
    })
  );
}

patientsControllerFindOne.PATH = '/thalea-patients/patients/{tenant}/{id}';
